import React, { Component } from 'react';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import { FILEPICKER_KEY } from '../constants';
import actions from '../redux/actions';

class FileUploader extends Component {
  filepicker = null;

  constructor(props) {
    super(props);
    this.state = {
      file: null,
      dropzoneActive: false,
    };
  }

  componentDidMount() {
    this.filepicker = require('filepicker-js');
    this.filepicker.setKey(FILEPICKER_KEY);
  }

  onDragEnter() {
    this.setState({
      dropzoneActive: true,
    });
  }

  onDragLeave() {
    this.setState({
      dropzoneActive: false,
    });
  }

  onDrop(files, rejected) {
    this.setState({
      dropzoneActive: false,
    });

    this.props.hideAlert();

    if (rejected.length) {
      this.props.alert(
        'success',
        'Please upload only .pdf, .doc and .docx files.'
      );
      return;
    }

    this.filepicker.store(
      files[0],
      (FPFile) => {
        this.setState({ file: FPFile });
        this.props.onUpload(FPFile);
        // this.props.alert('success', 'Upload successful!');
      },
      (FPError) => {
        console.error(FPError);
        this.props.alert(
          'error',
          'Oops! Your upload has failed. Please try again.'
        );
      }
    );
  }

  _handleClick(e) {
    e.preventDefault();
    this.props.hideAlert();

    this.filepicker.pick(
      {
        // extensions: ['.pdf', '.doc', '.docx'],
        container: 'modal',
        openTo: 'COMPUTER',
      },
      (FPFile) => {
        this.setState({ file: FPFile });
        this.props.onUpload(FPFile);
        // this.props.alert('success', 'Upload success!');
      },
      (FPError) => {
        console.error(FPError);
        this.props.alert('error', 'Upload failed!');
      }
    );
  }

  _handleFileRemove(e) {
    e.preventDefault();

    this.setState({ file: null });
    this.props.onUpload(null);
  }

  render() {
    const { file, dropzoneActive } = this.state;
    const dropStyle = {
      opacity: dropzoneActive ? 0.6 : 1,
    };

    return (
      <div className="file-upload">
        <div
          className={`upload-container ${dropzoneActive && 'active'}`}
          onClick={(e) => this._handleClick(e)}
        >
          <Dropzone
            // accept=".pdf, .doc, .docx"
            multiple={false}
            disableClick={true}
            style={dropStyle}
            onDrop={(files, rejected) => this.onDrop(files, rejected)}
            onDragEnter={() => this.onDragEnter()}
            onDragLeave={() => this.onDragLeave()}
          >
            {this.props.children ? (
              this.props.children
            ) : (
              <div className="drop-container">
                <div className="icon-container">
                  <div className="icon">
                    <FontAwesome name="plus" />
                  </div>
                </div>
                <div className="text">
                  <span className="text-gray">
                    {this.props.text || 'Upload File'}
                  </span>
                </div>
              </div>
            )}
          </Dropzone>
        </div>
        {file && this.props.fileUpload === 'uploaded' ? (
          <div
            className={`uploaded-file ${
              this.props.children && 'uploaded-file-name'
            }`}
          >
            <span>{file.filename}</span>
            <a className="remove" onClick={(e) => this._handleFileRemove(e)}>
              <FontAwesome name="close" />
            </a>
          </div>
        ) : null}
      </div>
    );
  }
}

FileUploader.defaultProps = {
  children: null,
  fileUpload: 'start',
};

FileUploader.propTypes = {
  children: PropTypes.node,
  fileUpload: PropTypes.string,
};

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
});

export default connect(null, mapDispatchToProps)(FileUploader);



// WEBPACK FOOTER //
// src/components/FileUploader.jsx